import axios from "axios";
import apiEndPoint from "./apiEndPoints";
import decrypt from "../hash-service/decrypt-service";
import encrypt from "../hash-service/encrypt-service";
const headerSetter = ({ Token, type = false }) => {
  return {
    headers: {
      Authorization: Token
        ? `Bearer ${Token}`
        : `Bearer ${localStorage.getItem("Token")}`,
      "Content-Type": type ? "multipart/form-data" : "application/json",
    },
    withCredentials: true,
  };
};
export const getApi = async ({ url, Token = false }) => {
  try {
    let { data, status } = await axios.get(url, headerSetter({ Token }));
    if (data.encryptData) {
      data = decrypt(data?.encryptData);
    }
    return { data, status };
  } catch (error) {
    if (error?.response?.data?.encryptData) {
      const resultVal = decrypt(error?.response?.data?.encryptData);
      if (
        (resultVal?.message === "logout the user" &&
          error?.response?.status === 403) ||
        (resultVal?.message === "jwt expired" &&
          error?.response?.status === 403)
      ) {
        let url = apiEndPoint().LOGOUT;
        console.log(url);
        const { status, data } = await fetch({ url });
        console.log(status, data);
        localStorage.clear();
        window.location.reload();
      }
      return { data: resultVal, status: error?.response?.status };
    } else {
      if (
        (error?.response?.data?.message === "logout the user" &&
          error?.response?.status === 403) ||
        (error?.response?.data?.message === "jwt expired" &&
          error?.response?.status === 403)
      ) {
        let url = apiEndPoint().LOGOUT;
        console.log(url);
        const { status, data } = await fetch({ url });
        console.log(status, data);
        localStorage.clear();
        window.location.reload();
      }
      return { data: error?.response?.data, status: error?.response?.status };
    }
  }
};

export const postApi = async ({ url, params, Token = false }) => {
  try {
    params = params?.withoutEncrypt ? params : { encryptData: encrypt(params) };
    let { data, status } = await axios.post(
      url,
      params,
      headerSetter({ Token })
    );
    if (data.encryptData) {
      data = decrypt(data?.encryptData);
    }
    return { data, status };
  } catch (error) {
    if (error?.response?.data?.encryptData) {
      const resultVal = decrypt(error?.response?.data?.encryptData);
      if (
        (resultVal?.message === "logout the user" &&
          error?.response?.status === 403) ||
        (resultVal?.message === "jwt expired" &&
          error?.response?.status === 403)
      ) {
        let url = apiEndPoint().LOGOUT;
        const { status, data } = await fetch({ url });
        console.log(status, data);
        localStorage.clear();
        window.location.reload();
      }
      return { data: resultVal, status: error?.response?.status };
    } else {
      if (
        (error?.response?.data?.message === "logout the user" &&
          error?.response?.status === 403) ||
        (error?.response?.data?.message === "jwt expired" &&
          error?.response?.status === 403)
      ) {
        let url = apiEndPoint().LOGOUT;
        const { status, data } = await fetch({ url });
        console.log(status, data);
        localStorage.clear();
        window.location.reload();
      }
      return { data: error?.response?.data, status: error?.response?.status };
    }
  }
};
